import { render } from "./EventBlackPatientManage.vue?vue&type=template&id=2cf8629d&scoped=true"
import script from "./EventBlackPatientManage.vue?vue&type=script&lang=js"
export * from "./EventBlackPatientManage.vue?vue&type=script&lang=js"

import "./EventBlackPatientManage.vue?vue&type=style&index=0&id=2cf8629d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf8629d"]])

export default __exports__